import { render, staticRenderFns } from "./depense-prestataire.html?vue&type=template&id=267ba97a&scoped=true&external"
import script from "./depense-prestataire.js?vue&type=script&lang=js&external"
export * from "./depense-prestataire.js?vue&type=script&lang=js&external"
import style0 from "./depense-prestataire.scss?vue&type=style&index=0&id=267ba97a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267ba97a",
  null
  
)

export default component.exports